import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { toRelativeTime, toLocalTime } from '../utils';
export const Timestamp = props => {
    const sx = props.sx ?? [];
    const isFutureTime = props.isFutureTime ?? false;
    const timestamp = props.value;
    return (_jsx(Box, { component: 'span', title: toLocalTime(timestamp), sx: [...(Array.isArray(sx) ? sx : [sx])], children: toRelativeTime(timestamp, isFutureTime) }));
};
//# sourceMappingURL=timestamp.js.map